import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Text,
  Button,
  Stack,
  IconButton,
  Input,
  useToast,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@chakra-ui/react";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";
import axios from "axios";
import EditBookModal from "./Edit_student";
import { BASE_URL } from "../../../../../Globalapi/Globalapi";

const AssignedStudentBook = () => {
  const [data, setData] = useState([]);
  const [books, setBooks] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedBook, setSelectedBook] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [issueIdToDelete, setIssueIdToDelete] = useState(null);
  const toast = useToast();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const schoolId = sessionStorage.getItem("school_id");
  const userId = sessionStorage.getItem("user_id");

  const issueApiUrl =
    `${BASE_URL}/admin/library/issues/list_issue.php`;
  const deleteApiUrl =
    `${BASE_URL}/admin/library/issues/delete_issue.php`;
  const booksApiUrl =
    `${BASE_URL}/admin/library/books/list_books.php`;
  console.log("api stud", issueApiUrl);

  useEffect(() => {
    fetchIssues();
    fetchBooks();
  }, [schoolId]);

  const fetchIssues = async () => {
    setLoading(true);
    try {
      const response = await axios.get(issueApiUrl, {
        params: { school_id: schoolId },
      });

      if (response.data.success) {
        // Filter to show only student issues
        const studentData = response.data.data.filter(
          (item) => item.student_id
        );
        setData(studentData);
      } else {
        console.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching issues:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchBooks = async () => {
    try {
      const response = await axios.get(booksApiUrl, {
        params: { school_id: schoolId },
      });
      if (response.data.success) {
        setBooks(response.data.data);
      } else {
        console.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching books:", error);
    }
  };

  const handleDelete = async () => {
    try {
      const response = await axios.delete(deleteApiUrl, {
        data: {
          school_id: schoolId,
          issue_id: issueIdToDelete,
          user_id: userId,
        },
      });

      if (response.data.success) {
        setData(data.filter((item) => item.id !== issueIdToDelete));
        toast({
          title: "Success",
          description: "Book issue deleted successfully.",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        onClose();
      } else {
        console.error(response.data.message);
        toast({
          title: "Error",
          description:
            response.data.message || "Failed to delete the book issue.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
        onClose();
      }
    } catch (error) {
      console.error("Error deleting book issue:", error);
      toast({
        title: "Error",
        description: "An unexpected error occurred.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      onClose();
    }
  };

  const filteredData = data
    .filter(
      (item) =>
        item.member_name &&
        item.member_name.toLowerCase().includes(searchQuery.toLowerCase())
    )
    .filter((item) => (selectedBook ? item.title === selectedBook : true));

  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const currentData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <Box>
      {/* Search and Filter */}
      <Flex justify="space-between" className="sb"  p={3}>
        <Select
          width="120px"
          value={rowsPerPage}
          onChange={(e) => setRowsPerPage(Number(e.target.value))}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={20}>20</option>
        </Select>
        <Flex direction="column" width="100%">
          <Flex
         
            gap={4}
            direction={{ base: "column", md: "row" }} // Vertical on small screens, horizontal on large screens
            width="100%"
            justify={{ base: "flex-start", md: "flex-end" }} // Left-aligned on small screens, right-aligned on larger screens
          >
            <Input
             ml={1}
              placeholder="Search by student name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              width={{ base: "100%", md: "250px" }} // Full width on small screens, fixed width on large screens
            />
            <Select
              placeholder="Filter by book"
              value={selectedBook}
              onChange={(e) => setSelectedBook(e.target.value)}
              width={{ base: "100%", md: "200px" }} // Full width on small screens, fixed width on large screens
            >
              {books.map((book) => (
                <option key={book.id} value={book.title}>
                  {book.title}
                </option>
              ))}
            </Select>
          </Flex>
        </Flex>
      </Flex>

      {/* Table */}
      {loading ? (
        <Text>Loading...</Text>
      ) : (
        <Box overflowX="auto" maxWidth="100%">
          <Table  sx={{
                "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              }}>
            <Thead>
              <Tr>
                <Th>Student Name</Th>
                <Th>Book Title</Th>
                <Th>Issue Date</Th>
                <Th>Due Date</Th>

                <Th>Status</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.map((row) => (
                <Tr key={row.id}>
                  <Td>{row.member_name || "N/A"}</Td>
                  <Td>{row.title}</Td>
                  <Td>{row.issue_date}</Td>
                  <Td>{row.due_date}</Td>

                  <Td>{row.status}</Td>
                  <Td>
                    <Stack direction="row" spacing={2}>
                      <EditBookModal issueId={row.id} />
                      <IconButton
                        icon={<DeleteIcon />}
                        colorScheme="red"
                        size="sm"
                        onClick={() => {
                          setIssueIdToDelete(row.id);
                          onOpen();
                        }}
                      />
                    </Stack>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      )}

      {/* Pagination */}
      <Flex justify="end" align="center" className="sb2" p={3}>
        <Button
          onClick={() => setCurrentPage(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>
        <Stack direction="row" spacing={2} mx={2}>
          {Array.from({ length: totalPages }, (_, i) => (
            <Button
              key={i}
              onClick={() => setCurrentPage(i + 1)}
              colorScheme={currentPage === i + 1 ? "teal" : "gray"}
            >
              {i + 1}
            </Button>
          ))}
        </Stack>
        <Button
          onClick={() => setCurrentPage(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Book Issue</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Are you sure you want to delete this book issue?</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="gray" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="red" onClick={handleDelete}>
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default AssignedStudentBook;
